.shimmerItem {
  height: 8px;
}

.shimmerItemSmall {
  max-width: 38%;
}

.shimmerItemLarge {
  max-width: 53%;
}
